/**
 * SSO Provider types
 */
export enum SsoProviderType {
  GOOGLE = 'google',
  AZURE_AD = 'azure_ad',
  OKTA = 'okta',
  ONELOGIN = 'onelogin',
  CUSTOM_SAML = 'custom_saml',
  CUSTOM_OIDC = 'custom_oidc',
}

/**
 * SSO Protocol types (matches Prisma SsoType enum)
 */
export enum SsoProtocol {
  SAML = 'SAML',
  OIDC = 'OIDC',
}

/**
 * Security recommendation types
 */
export enum RecommendationType {
  MFA_NOT_ENABLED = 'mfa_not_enabled',
  WEAK_SESSION_POLICY = 'weak_session_policy',
  SSO_NOT_CONFIGURED = 'sso_not_configured',
  KEY_ROTATION_OVERDUE = 'key_rotation_overdue',
  INACTIVE_USERS = 'inactive_users',
  WEAK_PASSWORD_POLICY = 'weak_password_policy',
  NO_IP_RESTRICTIONS = 'no_ip_restrictions',
  EXCESSIVE_SESSIONS = 'excessive_sessions',
  ADMIN_WITHOUT_MFA = 'admin_without_mfa',
  STALE_API_KEYS = 'stale_api_keys',
}

/**
 * Security recommendation severity levels.
 * Also used for document findings and other severity-based classifications.
 */
export enum RecommendationSeverity {
  INFO = 'info',
  LOW = 'low',
  MEDIUM = 'medium',
  HIGH = 'high',
  CRITICAL = 'critical',
}

/**
 * Security recommendation status
 */
export enum RecommendationStatus {
  ACTIVE = 'active',
  DISMISSED = 'dismissed',
  RESOLVED = 'resolved',
}

/**
 * User session status
 */
export enum SessionStatus {
  ACTIVE = 'active',
  EXPIRED = 'expired',
  REVOKED = 'revoked',
}

/**
 * SSO connection status
 */
export enum SsoConnectionStatus {
  CONNECTED = 'connected',
  DISCONNECTED = 'disconnected',
  ERROR = 'error',
  NOT_CONFIGURED = 'not_configured',
}
